const Quote = () => {

  return (
    <div className="power-up-container">
      <div className="power-up-content">
        <h1 className="font-medium">Let's Power Up Together!</h1>
        <p className="text-[17px] my-5 text-gray-600">
          Have questions or need expert electrical and solar solutions?
          <br />
          Our team is ready to assist you. Get in touch today!
        </p>

        <form className="power-up-form">
          <input 
            type="text" 
            placeholder="Enter Your Name" 
            name="name"
            required
          />
          <input 
            type="text" 
            placeholder="Write Your Phone" 
            name="phone"
            required
          />
          <select 
            name="service"
            required
          >
            <option value="">Select Service</option>
            <option>Solar Solutions</option>
            <option>Street Pole</option>
            <option>Electrical Services</option>
          </select>
          <button type="submit">Get Free Quotation</button>
        </form>
      </div>

      <div className="power-up-image">
        <img src="assets/img/man.png" alt="Man with headphones" />
      </div>
    </div>
  );
};

export default Quote;
